// src/components/cofounder/InsightCard.js
import React from 'react';
import { AlertTriangle, TrendingUp, Bell, Lightbulb, X } from 'lucide-react';

const typeConfig = {
  warning: { bg: 'bg-amber-50', border: 'border-amber-200', icon: AlertTriangle, iconColor: 'text-amber-500', badge: 'bg-amber-100 text-amber-700' },
  opportunity: { bg: 'bg-green-50', border: 'border-green-200', icon: Lightbulb, iconColor: 'text-green-500', badge: 'bg-green-100 text-green-700' },
  reminder: { bg: 'bg-blue-50', border: 'border-blue-200', icon: Bell, iconColor: 'text-blue-500', badge: 'bg-blue-100 text-blue-700' },
  trend: { bg: 'bg-purple-50', border: 'border-purple-200', icon: TrendingUp, iconColor: 'text-purple-500', badge: 'bg-purple-100 text-purple-700' }
};

const InsightCard = ({ insight, onDismiss, onAskAbout, compact = false }) => {
  const config = typeConfig[insight.type] || typeConfig.reminder;
  const Icon = config.icon;

  if (compact) {
    return (
      <div className={`rounded-lg border ${config.border} ${config.bg} p-2.5 cursor-pointer hover:shadow-sm transition-shadow`}
           onClick={() => onAskAbout && onAskAbout(insight)}>
        <div className="flex items-start gap-2">
          <Icon size={14} className={`${config.iconColor} mt-0.5 flex-shrink-0`} />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-800 truncate">{insight.title}</p>
          </div>
          {onDismiss && (
            <button onClick={(e) => { e.stopPropagation(); onDismiss(insight.id); }}
                    className="text-gray-400 hover:text-gray-600 flex-shrink-0">
              <X size={12} />
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-xl border ${config.border} ${config.bg} p-4`}>
      <div className="flex items-start gap-3">
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${config.badge}`}>
          <Icon size={16} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="text-sm font-semibold text-gray-800">{insight.title}</h4>
            <span className={`text-xs px-1.5 py-0.5 rounded-full ${config.badge} capitalize`}>{insight.type}</span>
          </div>
          <p className="text-sm text-gray-600 mb-2">{insight.description}</p>
          {insight.actionSuggestion && (
            <p className="text-xs text-gray-500 italic">{insight.actionSuggestion}</p>
          )}
          <div className="flex gap-2 mt-3">
            {onAskAbout && (
              <button onClick={() => onAskAbout(insight)}
                      className="px-3 py-1.5 bg-[#190192] text-white text-xs font-medium rounded-lg hover:bg-[#0f0075] transition-colors">
                Ask coFounder
              </button>
            )}
            {onDismiss && (
              <button onClick={() => onDismiss(insight.id)}
                      className="px-3 py-1.5 text-gray-600 text-xs font-medium rounded-lg border border-gray-300 hover:bg-white transition-colors">
                Dismiss
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightCard;
